<template>
    <div class="ui-select" ref="container" v-bind="binds.container">
        <!-- * 主体 -->
        <input class="ui-form-control" type="text" v-bind="binds.main" @click="methods.show" readonly />

        <!-- * 箭头 -->
        <UiIcon name="arrow" class="ui-select-arrow" @click="methods.show" />

        <!-- * 候选项 -->
        <Transition v-on="ons.animation">
            <div :class="css.viewer" class="ui-form-candidates" ref="body" v-if="visible" :style="{ zIndex: zIndex }">
                <div class="ui-form-candidate-container">
                    <div :class="css.candidates" class="ui-form-candidate-content max-h-[324px]">
                        <div class="mt-[4px] first:mt-[0px]" v-for="(value, index) in candidates" :key="index">
                            <div class="font-bold text-[12px] leading-[20px] mb-[4px]">{{ `${value.shortnanme}（${value.name}）` }}</div>
                            <div class="flex flex-wrap m-[-4px]">
                                <div
                                    class="transition duration-200 cursor-pointer border border-solid border-uicolor4 rounded-[2px] h-[30px] w-[50px] text-center m-[4px] hover:bg-color4"
                                    :class="{ 'text-emphas bg-color4': modelValue == codon }"
                                    v-for="codon in value.codons"
                                    v-on="ons.candidate(codon)">
                                    <span v-for="(c, k) in codon" :class="{ 'text-pathogenic': contrast.charAt(k) != c }">{{ c }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { node, UiIcon } from "various-ui";
//* 组件属性
import { UiSelectPropsOption, UiSelectEmits } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";

//* 组件属性注册
const define = defineProps(UiSelectPropsOption);
const emits = defineEmits(UiSelectEmits);

//* 组合函数
const { ons, vars, refs, nodes, binds, methods, computeds } = useComposable(define, emits);
const { visible } = refs;
const { container, body } = nodes;
const { candidates } = computeds;

//* 销毁事件
onBeforeUnmount(() => {
    //* 将内容从视图容器中移除
    body.value && node.remove(document.body, body.value);
    //* 注销观察者
    vars.observer?.disconnect();
});
</script>
